import React from "react";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useFilesPickerContext } from "../hooks/files-picker-context";

interface ModalFooterProps {
  onClose: () => void;
  onSelect: () => void;
  isSelectDisabled: boolean;
  mode?: "deal-form" | "document";
}

export const ModalFooter: React.FC<ModalFooterProps> = ({ onClose, onSelect, isSelectDisabled, mode = "document" }) => {
  const { selectedItemsCounter, loading } = useFilesPickerContext();

  return (
    <Stack flexDirection="row" justifyContent="space-between">
      {!!selectedItemsCounter && <Typography>{`${selectedItemsCounter} files selected`}</Typography>}
      <Stack flexDirection="row" alignItems="center" gap="10px">
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <>
            <Button variant="outlined" sx={{ minWidth: "53px" }} onClick={onClose}>
              Cancel
            </Button>
            <Button
              disabled={isSelectDisabled}
              variant="contained"
              sx={{ backgroundColor: "#071F35", minWidth: "46px" }}
              onClick={onSelect}
            >
              {mode === "deal-form" ? "Select and answer" : "Select"}
            </Button>
          </>
        )}
      </Stack>
    </Stack>
  );
};
